import { useCallback } from 'react';
import { compose } from 'ramda';
import { useDispatch } from 'react-redux';

import { createNotification } from '../store/notifications/actions';

export const useCreateNotification = () =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useCallback(compose(useDispatch(), createNotification), []);
